module.exports = __webpack_public_path__ + "img/man-with-cigar.935fff05.png";